import { render, staticRenderFns } from "./information-tab.vue?vue&type=template&id=4f627616&scoped=true"
import script from "./information-tab.vue?vue&type=script&lang=js"
export * from "./information-tab.vue?vue&type=script&lang=js"
import style0 from "./information-tab.vue?vue&type=style&index=0&id=4f627616&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f627616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f627616')) {
      api.createRecord('4f627616', component.options)
    } else {
      api.reload('4f627616', component.options)
    }
    module.hot.accept("./information-tab.vue?vue&type=template&id=4f627616&scoped=true", function () {
      api.rerender('4f627616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/units/components/information-tab.vue"
export default component.exports